export type GetInstanceConfig = {
  /** When Growthbook fails to initialize, this function is called. Use for custom error reporting/logging. */
  errorCallback?: (err: Error) => void
  /** Growthbook clientKey override - optional; will use prod if undefined */
  clientKey?: string
  /** Growthbook apiHost override - optional; will use prod if undefined */
  apiHost?: string
  /** Growthbook enableDevMode override - optional; will use false by default */
  enableDevMode?: boolean
  /** Growthbook nonce for visual Editor scripts - Optional nonce for the script tag */
  jsInjectionNonce?: string
  /** Growthbook subscribeToChanges - optional */
  subscribeToChanges?: boolean
  /**
   * Controls whether to bypass the experimentation configuration from the window object - optional.
   *
   * - `true`: Skips loading experimentation data and falls back to static config.
   * - `false`: Uses experimentation data if available.
   * - Defaults to `false` if not provided.
   **/
  bypassWindowConfig?: boolean
}

export const defaultGbHost = 'https://cdn.growthbook.io' as const
export const defaultSdkKey = 'sdk-HiXC19gXofXiYsT' as const
